import { BellIcon, ChartBarIcon, ClipboardDocumentIcon, HomeIcon, TableCellsIcon, UserPlusIcon } from "@heroicons/react/24/solid";
import React from "react";
import { Link } from "react-router-dom";
import useAppContext, { ACCOUNT_TYPES } from "state/AppContext";

export default function RecruiterTopNav() {
  const appContext = useAppContext();
  const { account, selectedRecruiter } = appContext;
  const RecruiterTopNavRoutes = {
    adminNavRoutes: {
      dashboardRoute: `/recruiters/${selectedRecruiter}`,
      clientsRoute: `/recruiters/${selectedRecruiter}/clients`,
      ordersRoute: `/recruiters/${selectedRecruiter}/orders`,
      analyticsRoute: `/recruiters/${selectedRecruiter}/analytics`,
      notificationsRoute: `/recruiters/${selectedRecruiter}/notifications`,
    },
    recruiterNavRoutes: {
      dashboardRoute: "/",
      clientsRoute: "/clients",
      ordersRoute: "/orders",
      analyticsRoute: "/analytics",
      notificationsRoute: "/notifications",
    },
  };

  const createClientRoute = "/create-client";
  const createOrderRoute = "/create-order";

  const { adminNavRoutes, recruiterNavRoutes } = RecruiterTopNavRoutes;
  const routes = account.accountType.type === ACCOUNT_TYPES.ADMIN ? adminNavRoutes : recruiterNavRoutes;

  const iconStyles = "block w-5 h-5 mb-1"
  const navStyle = "flex items-center justify-center flex-col py-1 text-gray-600 hover:text-gray-900 text-xs w-[80px]";


  return (
    <div className="z-10 fixed top-0 left-0 h-[60px] w-full bg-white border-b border-b-gray-300 px-4 py-1 flex justify-between">
      <ul className="flex items-center">
        <li>
          <Link className={navStyle} to={routes.dashboardRoute}>
            <HomeIcon className={iconStyles} />
            <span className="block">Dashboard</span>
          </Link>
        </li>
        <li>
          <Link className={navStyle} to={routes.clientsRoute}>
            <TableCellsIcon className={iconStyles} />
            <span className="block">Clients</span>
          </Link>
        </li>
        <li>
          <Link className={navStyle} to={routes.ordersRoute}>
          <TableCellsIcon className={iconStyles} />
            <span className="block">Orders</span>
          </Link>
        </li>
        <li>
          <Link className={navStyle} to={routes.analyticsRoute}>
            <ChartBarIcon className={iconStyles} />
            <span className="block">Analytics</span>
          </Link>
        </li>
        <li>
          <Link className={navStyle} to={routes.notificationsRoute}>
            <BellIcon className={iconStyles} />
            <span className="block">Notifications</span>
          </Link>
        </li>
      </ul>
      <ul className="flex items-center">
        <li>
          <Link className={navStyle} to={createClientRoute}>
            <UserPlusIcon className={iconStyles} />
            <span className="block">New Client</span>
          </Link>
        </li>
        <li>
          <Link className={navStyle} to={createOrderRoute}>
            <ClipboardDocumentIcon className={iconStyles} />
            <span className="block">New Order</span>
          </Link>
        </li>
      </ul>
    </div>
  );
}
